export const Canvas = () => (
    <canvas id="burning-canvas">
        Your browser does <strong>not support</strong> the <code>&lt;canvas&gt;</code> element.
    </canvas>
);
